import useEvent from '@lyearn/core/hooks/useEvent';
import { useTranslation } from '@lyearn/i18n';
import { CustomFilterRenderProps } from '@/components/FilterManager/types';

import { FileFragment } from '../../graphql/fragments/generated/file';
import TaskGroupByFilter from './TaskGroupByFilter';

type Props = CustomFilterRenderProps & {
  taskViewConfigs?: FileFragment['taskViewConfigs'];
  file?: FileFragment;
};

const TaskGroupByFilterContainer = (props: Props) => {
  const { t } = useTranslation();
  const { taskViewConfigs, filter, setFilter, file } = props;

  const filterId = 'groupBy';
  const value = filter[filterId] as string;

  const onChange = useEvent((nextValue: string) => {
    setFilter({ ...filter, [filterId]: nextValue });
  });

  const isMyTasks = file?.name == 'My Tasks';

  return (
    <TaskGroupByFilter
      defaultPlaceholder={t('Common:Filter.GroupBy')}
      filterId={filterId}
      isMyTasks={isMyTasks}
      taskViewConfigs={taskViewConfigs}
      value={value}
      onChange={onChange}
    />
  );
};

export default TaskGroupByFilterContainer;
